import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faPhone } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Grid, Typography } from "@mui/material"
import React from "react"
import { PhoneContactLinkProps } from "./PhoneContactLink.interfaces"
import { StyledBox, StyledButton } from "./PhoneContactLink.styled"

const PhoneContactLink: React.FC<PhoneContactLinkProps> = (props) => {
  return (
    <StyledButton href={"tel:" + props.phoneNumber}>
      <Grid container alignItems={"center"} justifyContent={"space-between"}>
        <Grid item>
          <Typography color={"MenuText"}>{props.name}</Typography>
        </Grid>
        <Grid item>
          <Grid container alignItems={"center"} justifyContent={"flex-end"}>
            <Grid item>
              <Typography color="textSecondary">{props.phoneNumber}</Typography>
            </Grid>
            <Grid item>
              <StyledBox>
                <FontAwesomeIcon icon={faPhone as IconProp} color="white" size="sm" />
              </StyledBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </StyledButton>
  )
}

export default PhoneContactLink
